// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jVn0","importantInfo":"styles_importantInfo__2jTl1"};